module.exports = __webpack_public_path__ + "img/LKW_Lbw.85d19fd7.svg";